export const REM_CASES: Record<string, string> = Object.fromEntries(Array.from({ length: 100 }, (_, i) => (i === 0 ? ['0', '0px'] : [String(i), `${i * 0.125}rem`])));
export const FRACTION_CASES: Record<string, string> = {
    '1/2': '50%',
    '1/3': '33.3333%',
    '2/3': '66.6667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '2/5': '40%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.6667%',
    '2/6': '33.3333%',
    '3/6': '50%',
    '4/6': '66.6667%',
    '5/6': '83.3333%',
    '1/12': '8.3333%',
    '2/12': '16.6667%',
    '3/12': '25%',
    '4/12': '33.3333%',
    '5/12': '41.6667%',
    '6/12': '50%',
    '7/12': '58.3333%',
    '8/12': '66.6667%',
    '9/12': '75%',
    '10/12': '83.3333%',
    '11/12': '91.6667%',
    full: '100%',
};

export const COLOR_CASES: Record<string, string> = {
    'blue-100': '#bfdbfe;',
    'blue-200': '#93c5fd;',
    'blue-300': '#60a5fa;',
    'blue-400': '#3b82f6;',
    'blue-500': '#2563eb;',
    'blue-600': '#1d4ed8;',
    'blue-700': '#1e40af;',
    'blue-800': '#1e3a8a;',
    'blue-900': '#1e3a73;',

    // Indigo
    'indigo-100': '#e0e7ff;',
    'indigo-200': '#c7d2fe;',
    'indigo-300': '#a5b4fc;',
    'indigo-400': '#818cf8;',
    'indigo-500': '#6366f1;',
    'indigo-600': '#4f46e5;',
    'indigo-700': '#4338ca;',
    'indigo-800': '#3730a3;',
    'indigo-900': '#312e81;',

    // Purple
    'purple-100': '#f3e8ff;',
    'purple-200': '#e9d5ff;',
    'purple-300': '#d8b4fe;',
    'purple-400': '#c084fc;',
    'purple-500': '#a855f7;',
    'purple-600': '#9333ea;',
    'purple-700': '#7e22ce;',
    'purple-800': '#6b21a8;',
    'purple-900': '#581c87;',

    // Pink
    'pink-100': '#fbcfe8;',
    'pink-200': '#f9a8d4;',
    'pink-300': '#f472b6;',
    'pink-400': '#ec4899;',
    'pink-500': '#db2777;',
    'pink-600': '#be185d;',
    'pink-700': '#9d174d;',
    'pink-800': '#831843;',
    'pink-900': '#701a3c;',

    // Red
    'red-100': '#fee2e2;',
    'red-200': '#fecaca;',
    'red-300': '#fca5a5;',
    'red-400': '#f87171;',
    'red-500': '#ef4444;',
    'red-600': '#dc2626;',
    'red-700': '#b91c1c;',
    'red-800': '#991b1b;',
    'red-900': '#7f1d1d;',

    // Orange
    'orange-100': '#ffedd5;',
    'orange-200': '#fed7aa;',
    'orange-300': '#fdba74;',
    'orange-400': '#fb923c;',
    'orange-500': '#f97316;',
    'orange-600': '#ea580c;',
    'orange-700': '#c2410c;',
    'orange-800': '#9a3412;',
    'orange-900': '#7c2d12;',

    // Yellow
    'yellow-100': '#fef9c3;',
    'yellow-200': '#fef08a;',
    'yellow-300': '#fde047;',
    'yellow-400': '#facc15;',
    'yellow-500': '#eab308;',
    'yellow-600': '#ca8a04;',
    'yellow-700': '#a16207;',
    'yellow-800': '#854d0e;',
    'yellow-900': '#713f12;',

    // Green
    'green-100': '#d1fae5;',
    'green-200': '#a7f3d0;',
    'green-300': '#6ee7b7;',
    'green-400': '#34d399;',
    'green-500': '#10b981;',
    'green-600': '#059669;',
    'green-700': '#047857;',
    'green-800': '#065f46;',
    'green-900': '#064e3b;',

    // Teal
    'teal-100': '#ccfbf1;',
    'teal-200': '#99f6e4;',
    'teal-300': '#5eead4;',
    'teal-400': '#2dd4bf;',
    'teal-500': '#14b8a6;',
    'teal-600': '#0d9488;',
    'teal-700': '#0f766e;',
    'teal-800': '#115e59;',
    'teal-900': '#134e4a;',

    // Cyan
    'cyan-100': '#cffafe;',
    'cyan-200': '#a5f3fc;',
    'cyan-300': '#67e8f9;',
    'cyan-400': '#22d3ee;',
    'cyan-500': '#06b6d4;',
    'cyan-600': '#0891b2;',
    'cyan-700': '#0e7490;',
    'cyan-800': '#155e75;',
    'cyan-900': '#164e63;',

    // Gray
    'gray-100': '#f3f4f6;',
    'gray-200': '#e5e7eb;',
    'gray-300': '#d1d5db;',
    'gray-400': '#9ca3af;',
    'gray-500': '#6b7280;',
    'gray-600': '#4b5563;',
    'gray-700': '#374151;',
    'gray-800': '#1f2937;',
    'gray-900': '#111827;',

    // Gray-Dark
    'gray-dark-100': '#d3d3d3;',
    'gray-dark-200': '#bababa;',
    'gray-dark-300': '#9f9f9f;',
    'gray-dark-400': '#7f7f7f;',
    'gray-dark-500': '#666666;',
    'gray-dark-600': '#4c4c4c;',
    'gray-dark-700': '#333333;',
    'gray-dark-800': '#1a1a1a;',
    'gray-dark-900': '#0d0d0d;',

    // Error
    'error-100': '#f9d4d9',
    'error-200': '#f3a9b2',
    'error-300': '#ec7d8b',
    'error-400': '#e65363',
    'error-500': '#a6192e',
    'error-600': '#850f22',
    'error-700': '#660818',
    'error-800': '#48040f',
    'error-900': '#2f0209',

    // Warning
    'warning-100': '#fff4d4',
    'warning-200': '#ffe9a9',
    'warning-300': '#ffde7d',
    'warning-400': '#ffd353',
    'warning-500': '#ff9900',
    'warning-600': '#cc7a00',
    'warning-700': '#995c00',
    'warning-800': '#663d00',
    'warning-900': '#331f00',

    // Success
    'success-100': '#d2f7dd',
    'success-200': '#a6efba',
    'success-300': '#79e798',
    'success-400': '#4cdf75',
    'success-500': '#04b34f',
    'success-600': '#038f3e',
    'success-700': '#026b2e',
    'success-800': '#01471d',
    'success-900': '#00230d',

    // Information
    'info-100': '#d4e6f9',
    'info-200': '#a9cdf3',
    'info-300': '#7db5ec',
    'info-400': '#539ce6',
    'info-500': '#0057b8',
    'info-600': '#004490',
    'info-700': '#003168',
    'info-800': '#001e40',
    'info-900': '#000b20',
};
